import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertPackageOptions } from './expert-package-options.component';

@Directive({
  selector: '[packagePlaceholderNullOnClick]'
})

export class PackagePlaceholderNull {
   constructor(private _elementRef : ElementRef , private expertPacOptions : ExpertPackageOptions) {
    }

    @Output()
    public packagePlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {   
            this.expertPacOptions.expertPackageOptions="";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-package-options/expert-package-placeholder-null.ts